import React, { useState } from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import iklImage from '../assets/ikl.png';
import '../styles/AboutPage.css';

function AboutPage() {
  const [flipped, setFlipped] = useState(false);

  const handleCardClick = () => setFlipped(!flipped);

  return (
    <>
      <Navbar />

      <main className="about-container">
        <div
          className={`flip-card ${flipped ? 'flipped' : ''}`}
          onClick={handleCardClick}
          role="button"
          tabIndex={0}
          onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') handleCardClick(); }}
        >
          <div className="flip-card-inner">

            {/* Front Side */}
            <div className="flip-card-front">
              <h2>İzmir Kız Lisesi Mezun Ağı</h2>

              <section>
                <p>
                  Mezun ağımız, öğrencilerimiz ve mezunlarımızın bir araya gelerek güçlü sosyal bağlar kurmasını sağlar.
                </p>
              </section>

              <section>
                <p>
                  Platformda okuldan haberler, önemli duyurular ve etkinlikler güncel olarak paylaşılarak,
                  herkesin gelişmelerden haberdar olması sağlanır.
                </p>
              </section>

              <section>
                <p>
                  Mezunlarımız, platform üzerinden iş hayatlarına dair paylaşımlar yapabilir ve iş hayatında birbirlerine destek olur;
                  böylece mezunlarımız arasında iş dünyasında güçlü bir dayanışma ağı oluşturulması hedeflenir.
                </p>
              </section>

              <section>
                <p>
                  Ayrıca öğrenciler, kariyer yolculuklarında deneyimli mezunlarımızdan destek alabilir,
                  mentorluk yapacak mezunları kolayca bulabilirler.
                </p>
              </section>

              <section>
                <p>
                  Hem sosyal anlamda hem de kariyer planlamasında birbirimize güç katan,
                  dayanışma dolu bir topluluk oluşturmak hedeflenmiştir.
                </p>
              </section>
            </div>

            {/* Back Side */}
            <div className="flip-card-back">
              <div className="image-wrapper">
                <img src={iklImage} alt="İzmir Kız Lisesi" className="main-photo" />
              </div>
            </div>

          </div>
        </div>
      </main>

      <Footer />
    </>
  );
}

export default AboutPage;
